import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, unref as _unref, withModifiers as _withModifiers, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3c57cb17"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "div-logo" }
const _hoisted_2 = { class: "no-uppercase" }
const _hoisted_3 = { class: "div-right-menu" }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { class: "no-uppercase" }
const _hoisted_6 = { key: 1 }
const _hoisted_7 = { class: "no-uppercase" }
const _hoisted_8 = ["href"]
const _hoisted_9 = ["href"]
const _hoisted_10 = ["href"]
const _hoisted_11 = ["href"]

import { inject, ref } from "vue";
import { useRouter } from "vue-router";
import { useAppStore } from "@/store/AppStore";
import { useAuthStore } from "@/store/AuthStore";

interface MenuItem {
  title: string;
  path: string;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'ApplicationBar',
  setup(__props) {

const router = useRouter();
const appStore = useAppStore();
const authStore = useAuthStore();
const defaultBookURL = inject("defaultBookURL") as string;

const showLeftIcon = ref(false);
const showRightDrawer = ref(false);

router.beforeEach((to) => {
  const pages = ["Book"];
  const currentPageName = to.name as string;

  if (pages.includes(currentPageName)) {
    showLeftIcon.value = true;
  } else {
    showLeftIcon.value = false;
  }
});

const leftMenuItems = [
  { title: "Book", path: defaultBookURL, target: "" },
  // { title: "Diplomatic Edition", path: "https://dtpteamonline.com/diplomatic", target: "_blank" },
  { title: "Diplomatic Edition", path: "/" },
  { title: "About Us", path: "https://www.dhammachaitipitaka.org/about-project", target: "_blank" },
  { title: "Contact", path: "https://www.dhammachaitipitaka.org/contact-us", target: "_blank" },
];

const rightMenuItems = [
  { title: "Login", path: "/login" },
  { title: "Register", path: "/register" },
];

const getMenuItems = (isSMAndDown: boolean) => {
  if (authStore.isAuthenticated) {
    const menu = [];

    if (isSMAndDown) {
      menu.push(
        { title: "Book", path: defaultBookURL },
        // { title: "Diplomatic Edition", path: "https://dtpteamonline.com/diplomatic" },
        { title: "Diplomatic Edition", path: "/" },
        { title: "About Us", path: "https://www.dhammachaitipitaka.org/about-project" },
        { title: "Contact", path: "https://www.dhammachaitipitaka.org/contact-us" }
      );
    }

    if (authStore.isAdmin) {
      menu.push({ title: "Admin", path: "/admin" });
    }

    menu.push({ title: "Logout", path: "/logout" });

    return menu;
  } else {
    return [
      { title: "Book", path: defaultBookURL },
      // { title: "Diplomatic Edition", path: "https://dtpteamonline.com/diplomatic" },
      { title: "Diplomatic Edition", path: "/" },
      { title: "About Us", path: "https://www.dhammachaitipitaka.org/about-project" },
      { title: "Contact", path: "https://www.dhammachaitipitaka.org/contact-us" },
      { title: "Login", path: "/login" },
      { title: "Register", path: "/register" },
    ];
  }
};

const handleMenuItemClick = (item: MenuItem): void => {
  if (item.title === "Logout") {
    logout();
  } else {
    router.push(item.path);
  }
};

const logout = () => {
  authStore.logout();
  router.push("/");
};

return (_ctx: any,_cache: any) => {
  const _component_v_app_bar_nav_icon = _resolveComponent("v-app-bar-nav-icon")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_v_app_bar_title = _resolveComponent("v-app-bar-title")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_toolbar_items = _resolveComponent("v-toolbar-items")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_list_item_title = _resolveComponent("v-list-item-title")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_list = _resolveComponent("v-list")!
  const _component_v_menu = _resolveComponent("v-menu")!
  const _component_v_app_bar = _resolveComponent("v-app-bar")!
  const _component_v_navigation_drawer = _resolveComponent("v-navigation-drawer")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_v_app_bar, {
      class: "app-bar",
      color: "#dc3545",
      height: "46",
      elevation: "0"
    }, {
      default: _withCtx(() => [
        (showLeftIcon.value && _ctx.$vuetify.display.mdAndDown)
          ? (_openBlock(), _createBlock(_component_v_app_bar_nav_icon, {
              key: 0,
              class: "text-white",
              onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_unref(appStore).toggleLeftBarDrawer()), ["stop"]))
            }))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_1, [
          _createVNode(_component_v_app_bar_title, null, {
            default: _withCtx(() => [
              _createVNode(_component_router_link, {
                to: "/",
                style: {"cursor":"pointer"}
              }, {
                default: _withCtx(() => [
                  _createTextVNode(" D-Tipiṭaka ")
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _createVNode(_component_v_toolbar_items, { class: "hidden-sm-and-down" }, {
          default: _withCtx(() => [
            (_openBlock(), _createElementBlock(_Fragment, null, _renderList(leftMenuItems, (item) => {
              return _createVNode(_component_v_btn, {
                flat: "",
                key: item.title,
                href: item.path,
                target: item.target
              }, {
                default: _withCtx(() => [
                  _createElementVNode("span", _hoisted_2, _toDisplayString(item.title), 1)
                ]),
                _: 2
              }, 1032, ["href", "target"])
            }), 64))
          ]),
          _: 1
        }),
        _createVNode(_component_v_spacer),
        _createElementVNode("div", _hoisted_3, [
          (!_unref(authStore).isAuthenticated)
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                _createVNode(_component_v_toolbar_items, { class: "hidden-sm-and-down" }, {
                  default: _withCtx(() => [
                    (_openBlock(), _createElementBlock(_Fragment, null, _renderList(rightMenuItems, (item) => {
                      return _createVNode(_component_v_btn, {
                        flat: "",
                        key: item.title,
                        to: item.path
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("span", _hoisted_5, _toDisplayString(item.title), 1)
                        ]),
                        _: 2
                      }, 1032, ["to"])
                    }), 64))
                  ]),
                  _: 1
                }),
                (_ctx.$vuetify.display.smAndDown)
                  ? (_openBlock(), _createBlock(_component_v_btn, {
                      key: 0,
                      icon: "mdi-dots-vertical",
                      variant: "text",
                      class: "text-white",
                      onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (showRightDrawer.value = !showRightDrawer.value), ["stop"]))
                    }))
                  : _createCommentVNode("", true)
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_6, [
                _createVNode(_component_v_btn, {
                  onClick: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (_ctx.$vuetify.display.smAndDown ? (showRightDrawer.value = !showRightDrawer.value) : null), ["stop"]))
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("span", _hoisted_7, _toDisplayString(_unref(authStore).user?.email), 1),
                    (_ctx.$vuetify.display.mdAndUp)
                      ? (_openBlock(), _createBlock(_component_v_menu, {
                          key: 0,
                          activator: "parent"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_list, null, {
                              default: _withCtx(() => [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(getMenuItems(_ctx.$vuetify.display.smAndDown), (item, index) => {
                                  return (_openBlock(), _createBlock(_component_v_list_item, {
                                    onClick: ($event: any) => (handleMenuItemClick(item)),
                                    key: index,
                                    value: index
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_v_list_item_title, null, {
                                        default: _withCtx(() => [
                                          _createTextVNode(_toDisplayString(item.title), 1)
                                        ]),
                                        _: 2
                                      }, 1024)
                                    ]),
                                    _: 2
                                  }, 1032, ["onClick", "value"]))
                                }), 128))
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                })
              ]))
        ])
      ]),
      _: 1
    }),
    (_ctx.$vuetify.display.smAndDown)
      ? (_openBlock(), _createBlock(_component_v_navigation_drawer, {
          key: 0,
          id: "app-bar-drawer-right-menu",
          modelValue: showRightDrawer.value,
          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((showRightDrawer).value = $event)),
          location: "top",
          height: "50px"
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(getMenuItems(_ctx.$vuetify.display.smAndDown), (item) => {
              return (_openBlock(), _createBlock(_component_v_list, {
                key: item.title,
                to: item.path
              }, {
                default: _withCtx(() => [
                  (item.title === 'Book')
                    ? (_openBlock(), _createElementBlock("a", {
                        key: 0,
                        href: _unref(defaultBookURL),
                        class: "nav-item nav-link",
                        style: {"cursor":"pointer"}
                      }, "Book", 8, _hoisted_8))
                    : (item.title === 'Diplomatic Edition')
                      ? (_openBlock(), _createElementBlock("a", {
                          key: 1,
                          href: item.path,
                          target: "_blank",
                          class: "nav-item nav-link",
                          style: {"cursor":"pointer"}
                        }, " Diplomatic Edition ", 8, _hoisted_9))
                      : (item.title === 'About Us')
                        ? (_openBlock(), _createElementBlock("a", {
                            key: 2,
                            href: item.path,
                            target: "_blank",
                            class: "nav-item nav-link",
                            style: {"cursor":"pointer"}
                          }, " About Us ", 8, _hoisted_10))
                        : (item.title === 'Contact')
                          ? (_openBlock(), _createElementBlock("a", {
                              key: 3,
                              href: item.path,
                              target: "_blank",
                              class: "nav-item nav-link",
                              style: {"cursor":"pointer"}
                            }, "Contact", 8, _hoisted_11))
                          : (item.path === '/logout')
                            ? (_openBlock(), _createElementBlock("a", {
                                key: 4,
                                onClick: _cache[3] || (_cache[3] = ($event: any) => (logout())),
                                class: "nav-item nav-link",
                                style: {"cursor":"pointer"}
                              }, "Logout"))
                            : (_openBlock(), _createBlock(_component_router_link, {
                                key: 5,
                                to: item.path,
                                style: {"cursor":"pointer","text-decoration":"none","color":"inherit"}
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(item.title), 1)
                                ]),
                                _: 2
                              }, 1032, ["to"]))
                ]),
                _: 2
              }, 1032, ["to"]))
            }), 128))
          ]),
          _: 1
        }, 8, ["modelValue"]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})